/* TZ Strip Load-More — AJAX-append products to home strips (Section Rendering API). */
(function () {
  if (window.__tzStripLoadMoreInit) return;
  window.__tzStripLoadMoreInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tz-strip-load-more]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.classList.contains('is-loading')) return;

    var handle = btn.getAttribute('data-collection-handle');
    var currentPage = parseInt(btn.getAttribute('data-current-page') || '1', 10);
    var nextPage = currentPage + 1;
    var tone = btn.getAttribute('data-tone') || 'white';
    if (!handle) return;

    btn.classList.add('is-loading');
    btn.disabled = true;
    var label = btn.querySelector('.tz-strip-loadmore__label');
    var originalLabel = label ? label.textContent : 'Mehr laden';
    if (label) label.textContent = 'Laden…';

    /* Section Rendering API — no alternate template needed, works in preview via session cookie */
    var url = '/collections/' + encodeURIComponent(handle) + '?section_id=tz-strip-fragment&page=' + nextPage;

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fragmentRoot = doc.querySelector('[data-tz-strip-cards]');
        if (!fragmentRoot) throw new Error('No fragment in response');
        var newCards = Array.prototype.slice.call(fragmentRoot.children);
        if (newCards.length === 0) { hideWrap(btn); return; }

        /* Find the grid for THIS button */
        var wrap = btn.closest('.tz-strip-loadmore');
        var grid = null;
        if (wrap && wrap.parentElement) grid = wrap.parentElement.querySelector('[data-tz-strip-grid]');
        if (!grid) {
          var p = btn.parentElement;
          while (p && p !== document.body) {
            var g = p.querySelector('[data-tz-strip-grid]');
            if (g) { grid = g; break; }
            p = p.parentElement;
          }
        }
        if (!grid) { console.warn('[tz-strip] no grid for button', btn); return; }

        /* Append cards (dark variant on navy plates) */
        newCards.forEach(function (card) {
          if (tone === 'navy' && card.classList && card.classList.contains('tz-product-card')) {
            card.classList.add('tz-product-card--dark');
          }
          grid.appendChild(card);
        });

        btn.setAttribute('data-current-page', String(nextPage));
        var hasNext = fragmentRoot.getAttribute('data-has-next') === '1';
        if (!hasNext) hideWrap(btn);

        var countEl = wrap ? wrap.querySelector('[data-tz-strip-visible]') : null;
        if (countEl) {
          var current = parseInt(countEl.textContent, 10) || 0;
          countEl.textContent = String(current + newCards.length);
        }
      })
      .catch(function (err) { console.error('[tz-strip] load-more error', err); })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (label) label.textContent = originalLabel;
      });
  });

  function hideWrap(btn) {
    var wrap = btn.closest('.tz-strip-loadmore');
    if (wrap) wrap.style.display = 'none';
  }
})();
